import React from "react";
import FinishStep from "./FinishStep";
import { StepsProp } from "../Components/SteppersData";
import ContinueButton from "../Pagination/ContinueButton";
import { useDarkModeStore } from "../../../../store/useDarkModeStore";
import { formatComponentName } from "../../../../common/GlobalFunctions";

interface InfoSectionProps {
    fieldName: string;
    activeStep: number;
    filteredSteps: StepsProp<any>[];
    goToNextStep: () => void;
}

const introductionParagraph = ` Welcome! In this step, we are gathering data related to company details, asset management, and procurement. You will fill in information about companies, categories, priorities, statuses, intervention types, contractors, departments, locations, and clients. Let's get started!`;
const finishParagraph = `Here is a preview of all the data you entered`;

const InfoSection = ({ fieldName, activeStep, filteredSteps, goToNextStep }: InfoSectionProps) => {
    const { darkMode } = useDarkModeStore();

    const isLastStep = filteredSteps.length - 1;
    const isFinishSection = fieldName === 'summary';
    const isIntroduction = fieldName === 'introduction';
    const componentName = formatComponentName(fieldName);

    return <>
        <div
            style={{ color: darkMode ? 'white' : 'black' }}
        >
            <h3 className="fw-bold">
                {isIntroduction ? 'Get Started' : componentName}
            </h3>
            {
                isFinishSection
                    ? finishParagraph
                    : <p className="fs-6 mt-4" style={{ color: darkMode ? "#C4C4C4" : '#32475C99' }}>
                        {
                            isIntroduction
                                ? introductionParagraph
                                : `Please  fill in the details for the ${componentName.toLocaleLowerCase()} below.`
                        }
                    </p>
            }
            {activeStep === isLastStep && <FinishStep />}
        </div>
        <ContinueButton
            activeStep={activeStep}
            filteredSteps={filteredSteps}
            goToNextStep={goToNextStep}
        />
    </>
}

export default InfoSection;